import { render, staticRenderFns } from "./TourTabsEmail.vue?vue&type=template&id=250fb3dc&scoped=true&"
import script from "./TourTabsEmail.vue?vue&type=script&lang=js&"
export * from "./TourTabsEmail.vue?vue&type=script&lang=js&"
import style0 from "./TourTabsEmail.vue?vue&type=style&index=0&id=250fb3dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250fb3dc",
  null
  
)

export default component.exports